// extracted by mini-css-extract-plugin
export default {"wrapperTooltip":"BimContractReadForm_wrapperTooltip__DP+yQ","wrapperPie":"BimContractReadForm_wrapperPie__gY7hx","wrapperPieTooltip":"BimContractReadForm_wrapperPieTooltip__3UwMR"};